import gql from 'graphql-tag';

export const SEARCH_GENRES = gql`
  query searchGenres ($idValue: String!) {
    SearchGenres(name:$idValue) {
      id,
      name
    }
  }
`;

export const GET_GENRE = gql`
  query getGenre (
    $id: ID,
    $name: String
  ) {
    Genre(
      id: $id,
      name: $name
    ) {
        id,
        name,
        mainGenre {
          id,
          name
        }
        subGenres {
          id,
          name
        }
        items {
         ...on Release {
           id
           title
         }
         ...on Component {
           id
           title
         }
         ...on Project {
           id
           title
         }
         ...on Party {
           id
           fullName
         }
         __typename
       }
    }
  }
`;

export const CREATE_GENRE = gql`
  mutation createGenre (
    $id: ID,
    $name: String
  ) {
    CreateGenre(
      id: $id,
      name: $name
    ) {
        id,
        name
    }
  }
`;

export const UPDATE_GENRE = gql`
  mutation updateGenre (
    $id: ID!,
    $name: String
  ) {
    UpdateGenre(
      id: $id,
      name: $name
    ) {
        id,
        name
    }
  }
`;

export const DELETE_GENRE = gql`
  mutation deleteGenre (
    $id: ID!
  ) {
  DeleteGenre(
    id: $id
  ) {
    id
  }
}
`;
// AddGenreSubGenres(
//   from: _GenreInput!
//   to: _GenreInput!
// ): _AddGenreSubGenresPayload
// RemoveGenreSubGenres(
//   from: _GenreInput!
//   to: _GenreInput!
// ): _RemoveGenreSubGenresPayload
// AddGenreMainGenre(
//   from: _GenreInput!
//   to: _GenreInput!
// ): _AddGenreMainGenrePayload
// RemoveGenreMainGenre(
//   from: _GenreInput!
//   to: _GenreInput!
// ): _RemoveGenreMainGenrePayload
// AddGenreArtists(
//   from: _GenreInput!
//   to: _ArtistInput!
// ): _AddGenreArtistsPayload
// RemoveGenreArtists(
//   from: _GenreInput!
//   to: _ArtistInput!
// ): _RemoveGenreArtistsPayload
// AddGenreLabels(from: _GenreInput!, to: _LabelInput!): _AddGenreLabelsPayload
// RemoveGenreLabels(
//   from: _GenreInput!
//   to: _LabelInput!
// ): _RemoveGenreLabelsPayload
// AddGenreProjects(
//   from: _GenreInput!
//   to: _ProjectInput!
// ): _AddGenreProjectsPayload
// RemoveGenreProjects(
//   from: _GenreInput!
//   to: _ProjectInput!
// ): _RemoveGenreProjectsPayload
// AddGenreReleases(
//   from: _GenreInput!
//   to: _ReleaseInput!
// ): _AddGenreReleasesPayload
// RemoveGenreReleases(
//   from: _GenreInput!
//   to: _ReleaseInput!
// ): _RemoveGenreReleasesPayload
